import cx from "classnames";
import type { Element, Node } from "React";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import "./ReportPagination.scss";
type Props = {
  page: number;
  pageTotal: number;
  onClickNewPage: (...args: Array<any>) => any; // updateReportPagination: Function
};

class ReportPagination extends Component<Props> {
  renderPaginationNumbers: () => Array<Element<"div">> = () => {
    let numArray = [];

    for (let i = 1; i <= this.props.pageTotal; i++) {
      let el = (
        <div
          key={i}
          onClick={() => {
            this.props.onClickNewPage(i);
          }}
          className={cx("report-pagination__number", {
            "report-pagination__number--selected": this.props.page === i,
          })}
        >
          {i}
        </div>
      );
      numArray.push(el);
    }

    return numArray;
  };

  // componentDidMount = () => {
  //   // let parent calculate footer position
  //   this.props.updateReportPagination(true);
  // };
  render(): Node {
    return (
      <React.Fragment>
        <div className="report-pagination">
          {this.props.page > 1 && (
            <div
              onClick={() => {
                this.props.onClickNewPage(this.props.page - 1);
              }}
              className="report-pagination__prev"
            >
              Prev
            </div>
          )}
          <div className="report-pagination__numbers">
            {this.renderPaginationNumbers()}
          </div>
          {this.props.page !== this.props.pageTotal && (
            <div
              onClick={() => {
                this.props.onClickNewPage(this.props.page + 1);
              }}
              className="report-pagination__next"
            >
              <FormattedMessage id="Next" />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ReportPagination;
